module.exports = __webpack_public_path__ + "static/media/signage-indoor-img80.1ced0efd.jpg";